<div
    [@.disabled]="isDisableAnimationByVersionApp"
    [class.old-device]="isDisableAnimationByVersionApp"
    class="container-scroll-main-ctr"
>
    <div
        [@.disabled]="!isPlayAnimation"
        [@stateHeader]="stateHeader"
        (@stateHeader.done)="animationHeaderDone($event)"
        class="container-header truncate"
        *ngIf="showHeader"
        [class.fixed-container]="isFixedContainer"
        [class.prevent-scroll]="preventScroll"
    >
        <span [textContent]="title"></span>
        <ng-content select="[slot=slotButton]"></ng-content>
        <navaar-chevron-icon  *ngIf="showIcon"
            (click)="close()"
            [style]="{
                      width: '18px',
                      float: 'left',
                      height: '18px'
                  }"
        ></navaar-chevron-icon>
    </div>
    <div
        id="container-scroll"
        class="main-container scroll"
        [@.disabled]="!isPlayAnimation"
        [@stateContainer]="state"
        (@stateContainer.done)="animationDone($event)"
        [class.fixed-container]="isFixedContainer"
        [class.prevent-scroll]="preventScroll"
    >
        <div>
            <div
                (click)="close()"
                class="container-close"
            >
                <navaar-close-icon
                    *ngIf="!showHeader"
                    [style]="{width: '10px', height: '10px'}"
                ></navaar-close-icon>
            </div>
        </div>
        <ng-content #fadeableContent></ng-content>
    </div>
</div>
